import { ChecklistCategory } from '../_models/checklist-category';

export class ChecklistItemInput {
  idChecklist: number;
  description: string;
  ChecklistCategory: ChecklistCategory;
  frequency: number;
}
